<template>
    <div id="main-layout">
        <div class="topbar bg-white d-flex justify-content-between align-items-center p-2 border-bottom">
            <div class="d-flex align-items-center col-md-4">
                <span class="app-name ms-3 text-dark">TradeLite</span>
            </div>
            <div class="d-flex align-items-center col-md-4">
                <img :src="logoUrl" alt="Company Logo" class="img-fluid mx-auto" style="max-height: 50px;" />
            </div>
            <div class="d-flex align-items-center col-md-4">
                <div class="ms-auto">{{ userName }}&nbsp;<a title="Log Out" href="" @click="logout"><i class="fas fa-sign-out-alt"></i></a></div>
            </div>
        </div>
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-2 sidebar border-end bg-white">
                    <div class="accordion" id="sidebarAccordion">
                        <div class="accordion-item border-0 no-arrow">
                            <h2 class="accordion-header" id="headingDashboard">
                                <router-link class="nav-link accordion-button collapsed" to="/dashboard">
                                    <i class="fas fa-tachometer-alt"></i>&nbsp;Dashboard
                                </router-link>
                            </h2>
                        </div>
                        <div v-if="hasTradeAuthority" class="accordion-item border-0">
                            <h2 class="accordion-header" id="headingTrades">
                                <button class="accordion-button collapsed border-0" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTrades" aria-expanded="false" aria-controls="collapseSecurities">
                                    <i class="fas fa-exchange-alt"></i>&nbsp;Trades
                                </button>
                            </h2>
                            <div id="collapseTrades" class="accordion-collapse collapse" aria-labelledby="headingTrades" data-bs-parent="#sidebarAccordion">
                                <div class="accordion-body">
                                    <ul class="nav flex-column">
                                        <li v-if="hasTradeInitiateAuthority" class="nav-item">
                                            <router-link class="nav-link" to="/trades/new">New</router-link>
                                        </li>
                                        <li v-if="hasTradeViewAuthority" class="nav-item">
                                            <router-link class="nav-link" to="/trades">List</router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div v-if="hasSecurityAuthority" class="accordion-item border-0">
                            <h2 class="accordion-header" id="headingSecurities">
                                <button class="accordion-button collapsed border-0" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSecurities" aria-expanded="false" aria-controls="collapseSecurities">
                                    <i class="fas fa-dollar"></i>&nbsp;Securities
                                </button>
                            </h2>
                            <div id="collapseSecurities" class="accordion-collapse collapse" aria-labelledby="headingSecurities" data-bs-parent="#sidebarAccordion">
                                <div class="accordion-body">
                                    <ul class="nav flex-column">
                                        <li v-if="hasSecurityInitiateAuthority" class="nav-item">
                                            <router-link class="nav-link" to="/securities/new">New</router-link>
                                        </li>
                                        <li class="nav-item">
                                            <router-link class="nav-link" to="/securities">Approved</router-link>
                                        </li>
                                        <li class="nav-item">
                                            <router-link class="nav-link" to="/security-changes">Changes</router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div v-if="hasCounterpartyAuthority" class="accordion-item border-0">
                            <h2 class="accordion-header" id="headingCounterparties">
                                <button class="accordion-button collapsed border-0" type="button" data-bs-toggle="collapse" data-bs-target="#collapseCounterparties" aria-expanded="false" aria-controls="collapseCounterparties">
                                    <i class="fas fa-handshake"></i>&nbsp;Counterparties
                                </button>
                            </h2>
                            <div id="collapseCounterparties" class="accordion-collapse collapse" aria-labelledby="headingCounterparties" data-bs-parent="#sidebarAccordion">
                                <div class="accordion-body">
                                    <ul class="nav flex-column">
                                        <li v-if="hasCounterpartyInitiateAuthority" class="nav-item">
                                            <router-link class="nav-link" to="/counterparties/new">New</router-link>
                                        </li>
                                        <li class="nav-item">
                                            <router-link class="nav-link" to="/counterparties">Approved</router-link>
                                        </li>
                                        <li class="nav-item">
                                            <router-link class="nav-link" to="/counterparty-changes">Changes</router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div v-if="hasTradingBookAuthority" class="accordion-item border-0">
                            <h2 class="accordion-header" id="headingTradingBooks">
                                <button class="accordion-button collapsed border-0" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTradingBooks" aria-expanded="false" aria-controls="collapseTradingBooks">
                                    <i class="fas fa-book"></i>&nbsp;Trading Books
                                </button>
                            </h2>
                            <div id="collapseTradingBooks" class="accordion-collapse collapse" aria-labelledby="headingTradingBooks" data-bs-parent="#sidebarAccordion">
                                <div class="accordion-body">
                                    <ul class="nav flex-column">
                                        <li v-if="hasTradingBookInitiateAuthority" class="nav-item">
                                            <router-link class="nav-link" to="/trading-books/new">New</router-link>
                                        </li>
                                        <li class="nav-item">
                                            <router-link class="nav-link" to="/trading-books">Approved</router-link>
                                        </li>
                                        <li class="nav-item">
                                            <router-link class="nav-link" to="/trading-book-changes">Changes</router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div v-if="hasOwnCustodianAuthority" class="accordion-item border-0">
                            <h2 class="accordion-header" id="headingOwnCustodians">
                                <button class="accordion-button collapsed border-0" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOwnCustodians" aria-expanded="false" aria-controls="collapseOwnCustodians">
                                    <i class="fas fa-bank"></i>&nbsp;Own Custodians
                                </button>
                            </h2>
                            <div id="collapseOwnCustodians" class="accordion-collapse collapse" aria-labelledby="headingOwnCustodians" data-bs-parent="#sidebarAccordion">
                                <div class="accordion-body">
                                    <ul class="nav flex-column">
                                        <li v-if="hasOwnCustodianInitiateAuthority" class="nav-item">
                                            <router-link class="nav-link" to="/own-custodians/new">New</router-link>
                                        </li>
                                        <li class="nav-item">
                                            <router-link class="nav-link" to="/own-custodians">Approved</router-link>
                                        </li>
                                        <li class="nav-item">
                                            <router-link class="nav-link" to="/own-custodian-changes">Changes</router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div v-if="hasReportViewAuthority" class="accordion-item border-0">
                            <h2 class="accordion-header" id="headingReports">
                                <button class="accordion-button collapsed border-0" type="button" data-bs-toggle="collapse" data-bs-target="#collapseReports" aria-expanded="false" aria-controls="collapseReports">
                                    <i class="fas fa-file-alt"></i>&nbsp;Reports
                                </button>
                            </h2>
                            <div id="collapseReports" class="accordion-collapse collapse" aria-labelledby="headingReports" data-bs-parent="#sidebarAccordion">
                                <div class="accordion-body">
                                    <ul class="nav flex-column">
                                        <li class="nav-item">
                                            <router-link class="nav-link" to="/reports/approved-trades">Approved Trades</router-link>
                                        </li>
                                        <li class="nav-item">
                                            <router-link class="nav-link" to="/reports/holdings">Holdings</router-link>
                                        </li>
                                        <li class="nav-item">
                                            <router-link class="nav-link" to="/reports/profit-loss">Profit/Loss</router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div v-if="hasUserManageAuthority" class="accordion-item border-0">
                            <h2 class="accordion-header" id="headingAccess">
                                <button class="accordion-button collapsed border-0" type="button" data-bs-toggle="collapse" data-bs-target="#collapseAccess" aria-expanded="false" aria-controls="collapseAccess">
                                    <i class="fas fa-user-shield"></i>&nbsp;Access Control
                                </button>
                            </h2>
                            <div id="collapseAccess" class="accordion-collapse collapse" aria-labelledby="headingAccess" data-bs-parent="#sidebarAccordion">
                                <div class="accordion-body">
                                    <ul class="nav flex-column">
                                        <li class="nav-item">
                                            <router-link class="nav-link" to="/roles">Roles</router-link>
                                        </li>
                                        <li class="nav-item">
                                            <router-link class="nav-link" to="/users">Users</router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="powered-by text-start mt-4">
                        <small>Powered by <a href="https://fosterlite.com" target="_blank">Fosterlite Solutions</a></small>
                    </div>
                </div>
                <div class="col-md-10 offset-md-2 router-view-padding">
                    <FloatingAlert />
                    <router-view />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FloatingAlert from '@/components/FloatingAlert.vue';
import eventBus from '@/utils/eventBus';
import { getAuthorities } from '@/utils/auth';

export default {
    components: {
        FloatingAlert
    },
    data() {
        return {
            logoUrl: process.env.VUE_APP_LOGO_URL,
            userName: localStorage.getItem('firstName') + " " + localStorage.getItem('lastName'),
            authorities: []
        };
    },
    computed: {
        hasUserManageAuthority() {
            return this.authorities.includes('USER_MANAGE');
        },
        hasSettingsManageAuthority() {
            return this.authorities.includes('SETTINGS_MANAGE')
        },
        hasOwnCustodianAuthority() {
            return this.authorities.includes('OWN_CUSTODIAN_VIEW') || this.authorities.includes('OWN_CUSTODIAN_INITIATE') || this.authorities.includes('OWN_CUSTODIAN_APPROVE');
        },
        hasOwnCustodianInitiateAuthority() {
            return this.authorities.includes('OWN_CUSTODIAN_INITIATE');
        },
        hasOwnCustodianApproveAuthority() {
            return this.authorities.includes('OWN_CUSTODIAN_APPROVE');
        },
        hasTradingBookAuthority() {
            return this.authorities.includes('TRADING_BOOK_VIEW') || this.authorities.includes('TRADING_BOOK_INITIATE') || this.authorities.includes('TRADING_BOOK_APPROVE');
        },
        hasTradingBookInitiateAuthority() {
            return this.authorities.includes('TRADING_BOOK_INITIATE');
        },
        hasTradingBookApproveAuthority() {
            return this.authorities.includes('TRADING_BOOK_APPROVE');
        },
        hasCounterpartyAuthority() {
            return this.authorities.includes('COUNTERPARTY_VIEW') || this.authorities.includes('COUNTERPARTY_INITIATE') || this.authorities.includes('COUNTERPARTY_APPROVE');
        },
        hasCounterpartyInitiateAuthority() {
            return this.authorities.includes('COUNTERPARTY_INITIATE');
        },
        hasCounterpartyApproveAuthority() {
            return this.authorities.includes('COUNTERPARTY_APPROVE');
        },
        hasSecurityAuthority() {
            return this.authorities.includes('SECURITY_VIEW') || this.authorities.includes('SECURITY_INITIATE') || this.authorities.includes('SECURITY_APPROVE');
        },
        hasSecurityInitiateAuthority() {
            return this.authorities.includes('SECURITY_INITIATE');
        },
        hasSecurityApproveAuthority() {
            return this.authorities.includes('SECURITY_APPROVE');
        },
        hasTradeAuthority() {
            return this.authorities.includes('TRADE_VIEW') || this.authorities.includes('TRADE_INITIATE') || this.authorities.includes('TRADE_APPROVE');
        },
        hasTradeViewAuthority() {
            return this.authorities.includes('TRADE_VIEW');
        },
        hasTradeInitiateAuthority() {
            return this.authorities.includes('TRADE_INITIATE');
        },
        hasTradeApproveAuthority() {
            return this.authorities.includes('TRADE_APPROVE');
        },
        hasReportViewAuthority() {
            return this.authorities.includes('REPORT_VIEW');
        }
    },
    mounted() {
        this.fetchAuthorities();
    },
    methods: {
        async fetchAuthorities() {
            this.authorities = await getAuthorities() || [];
        },
        logout() {
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('mfaVerified');
            this.$router.push('/');
            eventBus.emit('show-alert', {
                message: 'You have logged out successfully.',
                type: 'success'
            });
        }
    }
};
</script>

<style>
.sidebar {
    height: calc(100vh - 60px);
    position: fixed;
    top: 60px;
    left: 0;
    padding-top: 20px;
    overflow-y: auto;
    transition: width 0.3s;
}
.topbar {
    height: 60px;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
}
.app-name {
    font-size: 1.5rem;
    font-weight: bold;
}
.container-fluid {
    margin-top: 60px;
}
.accordion-item {
    border: none;
}
.accordion-button {
    border: none;
}
.no-arrow .accordion-button::after {
    display: none;
}
.router-view-padding {
    padding: 30px 30px;
}
.powered-by {
    position: absolute;
    bottom: 20px;
    width: 80%;
}
</style>